import type { FaireBrandEntity } from "../../entity_types/brand";

export const b_a8n58zvndo: FaireBrandEntity = {
  token: "b_a8n58zvndo",
  type: "brand",
  name: "Abbott",
  avatarUrl:
    "https://cdn.faire.com/fastly/4c64c02474b088bc204b4515a720db6c584d2be52e591222354ebbf0b504c722.png",
  bannerUrl:
    "https://cdn.faire.com/fastly/e98011fd7c29b84dc2729c49067aac93a2adbe35159dd6234be8b182adf2f4f6.jpeg",
  logoUrl:
    "https://cdn.faire.com/fastly/4c64c02474b088bc204b4515a720db6c584d2be52e591222354ebbf0b504c722.png",
  heroImageUrl:
    "https://cdn.faire.com/fastly/e98011fd7c29b84dc2729c49067aac93a2adbe35159dd6234be8b182adf2f4f6.jpeg",
  location: "ON, CAN",
  minimumOrderDollars: 200,
  rating: 4.9,
  reviewCount: 688,
  isTopShop: true,
  isInsider: false,
  description:
    '*No Tariff Surprises at Abbott – We ensure clear, upfront pricing with no hidden fees, and our strong supply chain keeps your orders reliable and hassle-free.\n\nOur tagline, "Home + Happiness" truly encapsulates our mission. We find immense joy in curating and creating beautifully-designed gifts and home décor items that have the power to bring happiness to everyone. We are deeply passionate about what we do because it allows us to combine two essential elements in life: home and happiness. \n\t\t\nIn 1949, Abbott was established as a family-run business, and we are honored to continue that legacy as a third-generation company. Our founder, Ben Abbott, embarked on this journey with a humble one-man operation, introducing imported kitchen gadgets from England at county fairs throughout the country. Through dedication and hard work, we have evolved into one of the prominent vendors of gifts and home decor in North America, proudly serving our customers with quality products that bring happiness to their homes.\t',
  meta: {
    source: "api",
    importedAt: "2026-05-06T19:46:17.269Z",
    importedBy: "entity-db-cli",
  },
};
